import "./style.css";
import layout from "./layout.html";
import Text from "@blocks/Text";
import CustomImage from "@blocks/Image";
import Credits from "@blocks/Credits";

export default class Cover {
  static selector = ".cover";

  constructor(block, attrs) {
    this.block = block;

    this.block.innerHTML = layout;

    this.imageNode = this.block.querySelector(".image");
    this.textNode = this.block.querySelector(".text");
    this.creditsNode = this.block.querySelector(".credits");
    this.titleNumberNode = this.block.querySelector(".cover__title__number");
    this.titleTextNode = this.block.querySelector(".cover__title__text");
    this.arrowNode = this.block.querySelector(".cover__caption__arrow");

    this.attributes = attrs;
  }

  setupTitle = () => {
    this.titleNumberNode.textContent = `0${this.attributes.title.number}.`;
    this.titleTextNode.textContent = this.attributes.title.text;
  };

  setup = async () => {
    return new Promise(async (resolve) => {
      await new CustomImage(this.imageNode, this.attributes.image).onReady();
      await new Text(this.textNode, this.attributes.text).onReady();
      await new Credits(this.creditsNode, this.attributes.credits).onReady();

      this.setupTitle();

      if (this.attributes.soon) {
        this.block.classList.add("cover--soon");
      }

      resolve();
    });
  };

  onReady = async () => {
    return new Promise(async (resolve) => {
      this.mounted = true;
      await this.setup();
      resolve();
    });
  };
}
